export const MARK_AS_READ = 'markAsRead';
export const MARK_AS_UNREAD = 'markAsUnread';
export const MARK_ALL_AS_READ = 'markAllAsRead';
export const TOGGLE_READ_STATE = 'toggleReadState';
